import { CommonConfig, common as commonCore } from "src/index";

export const common: CommonConfig = {
    ...commonCore,
    // Impostare qui gli override per i valori della configurazione comune tra sviluppo e produzione
    id: 'econoMIA',
    name: 'econoMIA',
    instanceVersion: "1.1.3",
    logo: 'assets/images/logoEconoMIA.png',
    logoAlt: 'assets/images/logoEconoMIA.png',

    defaultLanguage: 'it',
    customLanguageResourcesPrefixes: ['/assets/i18n/'],

    hideChat: true,
    hideChatToggler: true,

    canNavigateModulesFromDetail: true,

    loginModule: {
        ...commonCore.loginModule,
        customPasswordForgottenMessage: 'Se hai dimenticato la password, contatta <a class="underline text-blue-600" href="mailto:corsi.fric@actionaid.org">FRIC</a>'
    },

    dashboardModule: {
        ...commonCore.dashboardModule,
        hideSearch: true,
    },

    myCoursesModule: {
        ...commonCore.myCoursesModule,
        hideAdvancedSearch: true,
    },

    myGuidesModule: {
        ...commonCore.myGuidesModule,
        hideAdvancedSearch: true,
    },

    calendarModule: {
        ...commonCore.calendarModule,
        hideFooter: true,
        hideMetaCredits: true,
        facetField: 'courseId',
        colorPalette: [
            ...commonCore.calendarModule?.colorPalette ?? [] // To customize comment this line and add custom colors
        ],
        calendlyDefault: {
            bgColor: "#fb6c2a",
            textColor: "#454444",
        },
        disableCalendly: true,
    },

    viewerModule: {
        ...commonCore.viewerModule,
        liquidViewer: {
            ...commonCore.viewerModule?.liquidViewer,
            customCssPath: 'assets/liquidViewerCustomizations.css',
        },
    },

    registrationModule: {
        ...commonCore.registrationModule,
        registrationType: 'simple',
    },

    userProfileModule: {
        ...commonCore.userProfileModule,
        hideSkillsConfiguration: true,
    },

    analytics: {
        ...commonCore.analytics,
        enable: true,
        type: 'InternalTracking',
    },

    helpModule: {
        ...commonCore.helpModule,
        supportEmail: 'corsi.fric@actionaid.org',
    }
};
